import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { PersonalSettings } from '../webApi/DataModels'
import webApi from '../webApi'
import { AxiosResponse } from '../../node_modules/axios'
import { cloneDeep } from 'lodash'
class PersonalSettingsState {
  personalSettings: PersonalSettings = {
    Default_Countries: [],
    Default_Customers: [],
    Default_Providers: [],
    Default_Tags: [],
    Default_Parcel_Status: [],
    Default_Service_Levels: [],
    Default_Events: [],
    Default_Postal_Code_From: '',
    Default_Postal_Code_To: '',
    Default_Flow: 'Forward',
    Default_Date: 0,
    Default_Grouping: 'Customer'
  }

  cachedPersonalSettings:PersonalSettings = null
}
const mutations = <MutationTree<PersonalSettingsState>>{
  setDefaultCountries (state: PersonalSettingsState, countries: number[]) {
    state.personalSettings.Default_Countries = countries
  },
  setDefaultCustomers (state: PersonalSettingsState, customers: number[]) {
    state.personalSettings.Default_Customers = customers
  },
  setDefaultProviders (state: PersonalSettingsState, providers: number[]) {
    state.personalSettings.Default_Providers = providers
  },
  setDefaultTags (state: PersonalSettingsState, tags: number[]) {
    state.personalSettings.Default_Tags = tags
  },
  setDefaultParcelStatus (state: PersonalSettingsState, parcelStatus: number[]) {
    state.personalSettings.Default_Parcel_Status = parcelStatus
  },
  setDefaultServiceLevels (state: PersonalSettingsState, serviceLevels: number[]) {
    state.personalSettings.Default_Service_Levels = serviceLevels
  },
  setDefaultEvents (state: PersonalSettingsState, events: number[]) {
    state.personalSettings.Default_Events = events
  },
  setDefaultDate (state: PersonalSettingsState, date: number) {
    state.personalSettings.Default_Date = date
  },
  setDefaultPostalCodeFrom (state: PersonalSettingsState, postalCodeFrom: string) {
    state.personalSettings.Default_Postal_Code_From = postalCodeFrom
  },
  setDefaultPostalCodeTo (state: PersonalSettingsState, postalCodeTo: string) {
    state.personalSettings.Default_Postal_Code_To = postalCodeTo
  },
  setDefaultFlow (state: PersonalSettingsState, flow: string) {
    state.personalSettings.Default_Flow = flow
  },
  setDefaultGrouping (state: PersonalSettingsState, grouping: string) {
    state.personalSettings.Default_Grouping = grouping
  },
  setPersonalSettings (state: PersonalSettingsState, personalSettings: any) {
    state.personalSettings = personalSettings
    state.personalSettings.Default_Countries = state.personalSettings.Default_Countries || []
    state.personalSettings.Default_Customers = state.personalSettings.Default_Customers || []
    state.personalSettings.Default_Providers = state.personalSettings.Default_Providers || []
    state.personalSettings.Default_Tags = state.personalSettings.Default_Tags || []
    state.personalSettings.Default_Parcel_Status = state.personalSettings.Default_Parcel_Status || []
    state.personalSettings.Default_Service_Levels = state.personalSettings.Default_Service_Levels || []
    state.personalSettings.Default_Events = state.personalSettings.Default_Events || []
    state.personalSettings.Default_Flow = state.personalSettings.Default_Flow || 'Forward'
    state.personalSettings.Default_Postal_Code_From = state.personalSettings.Default_Postal_Code_From || ''
    state.personalSettings.Default_Postal_Code_To = state.personalSettings.Default_Postal_Code_To || ''
    state.personalSettings.Default_Grouping = state.personalSettings.Default_Grouping || 'Customer'
  },
  reset (state:PersonalSettingsState) {
    state.personalSettings = {
      Default_Countries: [],
      Default_Customers: [],
      Default_Providers: [],
      Default_Tags: [],
      Default_Parcel_Status: [],
      Default_Service_Levels: [],
      Default_Events: [],
      Default_Postal_Code_From: '',
      Default_Postal_Code_To: '',
      Default_Flow: 'Forward',
      Default_Date: 0,
      Default_Grouping: 'Customer'
    }
  },
  cacheSettings (state:PersonalSettingsState):void {
    state.cachedPersonalSettings = cloneDeep(state.personalSettings)
  },
  resetSettingsFromCache (state:PersonalSettingsState) {
    state.personalSettings = state.cachedPersonalSettings
  }
}
const actions = <ActionTree<PersonalSettingsState, any>>{
  reset (store: ActionContext<PersonalSettingsState, any>):void {
    store.commit('reset')
  },
  savePersonalSettings (store: ActionContext<PersonalSettingsState, any>): Promise<any> {
    return webApi.personalSettings.save_Personal_Settings(store.state.personalSettings)
  },
  loadPersonalSettings (store: ActionContext<PersonalSettingsState, any>): Promise<any> {
    return new Promise((resolve, reject) => {
      webApi.personalSettings.get_Personal_Settings().then((response: AxiosResponse) => {
        if (response.data === null) {
          store.commit('reset')
        } else {
          try {
            store.commit('setPersonalSettings', JSON.parse(response.data))
          } catch (error) {
            store.commit('reset')
          }
        }
        resolve(response.data)
      }).catch((error) => {
        reject(error)
      })
    })
  }

}
const getters = <GetterTree<PersonalSettingsState, any>>{
  defaultCountries: (state: PersonalSettingsState): number[] => {
    return state.personalSettings.Default_Countries
  },
  defaultCustomers: (state: PersonalSettingsState): number[] => {
    return state.personalSettings.Default_Customers
  },
  defaultProviders: (state: PersonalSettingsState): number[] => {
    return state.personalSettings.Default_Providers
  },
  defaultTags: (state: PersonalSettingsState): number[] => {
    return state.personalSettings.Default_Tags
  },
  defaultDate: (state: PersonalSettingsState): number => {
    return state.personalSettings.Default_Date
  },
  defaultGrouping: (state: PersonalSettingsState): string => {
    return state.personalSettings.Default_Grouping
  },
  defaultParcelStatus (state: PersonalSettingsState): number[] {
    return state.personalSettings.Default_Parcel_Status
  },
  defaultServiceLevels (state: PersonalSettingsState): number[] {
    return state.personalSettings.Default_Service_Levels
  },
  defaultEvents (state: PersonalSettingsState): number[] {
    return state.personalSettings.Default_Events
  },
  defaultPostalCodeFrom (state: PersonalSettingsState): string {
    return state.personalSettings.Default_Postal_Code_From
  },
  defaultPostalCodeTo (state: PersonalSettingsState): string {
    return state.personalSettings.Default_Postal_Code_To
  },
  defaultFlow (state: PersonalSettingsState):string {
    return state.personalSettings.Default_Flow
  }
}
export default ({
  namespaced: true,
  state: new PersonalSettingsState(),
  mutations,
  actions,
  getters
})
